import { OnInit } from '@angular/core';
import { DPAccount } from './dp-account';
import { DPRole } from './dp-role';

export class DPUser {
  user_id: number;
  id_account: number;
  user_email: string;
  first_name: string;
  last_name: string;
  mobile_number: string;
  ddi_number: string;
  skype_id: string;
  linkedin: string;
  status: number;
  logged_in_before: number;
  account: DPAccount;
  roles: string[];
  created_on: string;
  new_password: string;
  confirmPassword: string;
  title: string;
  department: string;
  account_information: string;
  email_sent: number;
  last_logged_in_date: string;
  job_title: string;
  location: string;
  business_unit: string;
  parrot_touch_point: string;
  region: string;
  notes: string;
  modules: any;
  settings: any;
  notifications: any;




  constructor() {
    this.account = new DPAccount();
    this.roles = new Array<string>();
  }
}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-user.ts